var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPulse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#1d0e3d;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -113.97)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.494,120a.494.494,0,0,0,.494-.495v-3.779a.752.752,0,0,1,.75-.752H12.262a.752.752,0,0,1,.75.752v3.728a.494.494,0,1,0,.988,0v-3.728a1.741,1.741,0,0,0-1.738-1.741h-.854c-4.677-.022-3.913-.015-8.816,0H1.738A1.742,1.742,0,0,0,0,115.725V119.5A.494.494,0,0,0,.494,120Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.506,294.809a.494.494,0,0,0-.494.495v2.857a.752.752,0,0,1-.75.752H1.738a.752.752,0,0,1-.75-.752v-2.806a.494.494,0,1,0-.988,0v2.806A1.742,1.742,0,0,0,1.738,299.9c4.635,0,7.548.022,10.524,0A1.742,1.742,0,0,0,14,298.16V295.3A.494.494,0,0,0,13.506,294.809Z",
    transform: "translate(0 -171.94)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M43.329,198.769H42.285l-1.426-2.661a.493.493,0,0,0-.87,0l-1.946,3.631-1.5-2.807a.493.493,0,0,0-.87,0l-.984,1.837H33.591a.495.495,0,0,0,0,.989H34.98a.493.493,0,0,0,.435-.261l.689-1.286,1.5,2.807a.493.493,0,0,0,.87,0l1.946-3.631,1.131,2.11a.493.493,0,0,0,.435.26h1.339a.495.495,0,0,0,0-.989Zm0,0",
    transform: "translate(-31.46 -77.849)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.495,256.829A.495.495,0,1,0,0,256.335.5.5,0,0,0,.495,256.829Zm0,0",
    transform: "translate(0 -134.877)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M263.995,254.809a.495.495,0,1,0,.495.495A.5.5,0,0,0,263.995,254.809Zm0,0",
    transform: "translate(-250.489 -133.897)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulse);
export default __webpack_public_path__ + "static/media/pulse.50618f2b120371e4ed52fb60e3185b11.svg";
export { ForwardRef as ReactComponent };